<template>
<pop-up-layout 
  :title="$t('promociones.scoring')"
  :aceptar="$t('general.misc.guardarCambios')"
  :loading="loading"
  :saving="waitingForLoad"
  :loadingText="$t('general.misc.cargando')"
  :disabled="!cambiado"
  @volver="$parent.hide()"
  @aceptar="guardar()"
>
  <v-layout column justify-center align-center my-4>
    <o-description-title class="text-xs-center mb-1">
      {{$t('promociones.textoScoring', {promo: promocion.descripcion})}}
    </o-description-title>
    <o-description-title class="text-xs-center mb-2">
      {{$t('promociones.scoringAviso')}}
    </o-description-title>
    <v-flex xs12 md6 lg4 xl4 px-2>
      <v-form ref="form" v-model="valid" @submit.prevent="guardar">
        <o-numeric-text-field
          :label="$t('promociones.scoringLabel')"
          :rulesProps="[rules.required, rules.porcentaje]"
          v-model="tasaScoring"
          suffix="%"
        />
      </v-form>
    </v-flex>
    <o-base-center-text v-if="tasaScoring > 0">
      {{$t('promociones.scoringTasa', {
        importe: $options.filters['currency'](10*tasaScoring)
      })}}
    </o-base-center-text>
  </v-layout>
</pop-up-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import rulesMixin from '@/mixins/rules.js'

export default {
  mixins: [rulesMixin],
  props: {
    codigoPromocion: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      waitingForLoad: false,
      cambiado: false,
      tasaScoring: 0,
      tasaScoringBase: 0,
      loading: true,
      valid: true
    }
  },
  async created () {
    try {
      this.loading = true
      await this.loadPromocion(this.codigoPromocion)
      this.tasaScoring = this.promocion.tasaScoring ? this.promocion.tasaScoring.porcentaje : 0
      this.tasaScoringBase = this.tasaScoring
      await this.$nextTick()
      this.loading = false
    } catch (error) {
      this.waitingForLoad = false
      if (!error.code || error.code !== 1) {
        this.addAlert({texto: error.message, color: 'error'})
      }
    }
  },
  mounted () {
    window.addEventListener('beforeunload', this.alertPreRefresh)
  },
  beforeDestroy () {
    this.$emit('cambiado', false)
    window.removeEventListener('beforeunload', this.alertPreRefresh)
  },
  computed: {
    ...mapGetters({
      promocion: 'promociones/getActual'
    })
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadPromocion: 'promociones/loadPromocion',
      modificarTasaScoring: 'scoring/modificarTasaScoring'
    }),
    alertPreRefresh (e) {
      if (this.cambiado) {
        let message = this.$t('general.misc.alertPreRefresh')
        e = e || window.event
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      }
    },
    async guardar () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
        return
      }
      try {
        this.waitingForLoad = true
        this.$parent.noCerrarInterno = true
        await this.modificarTasaScoring({
          codigoPromocion: this.codigoPromocion,
          porcentaje: this.tasaScoring
        })
        this.$emit('cambiado', false)
        this.$emit('recargar')
        this.$parent.hide()
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        this.addAlert({texto: this.$t('general.misc.cambiosGuardadosExito'), color: 'success'})
      } catch (error) {
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  },
  watch: {
    tasaScoring: {
      deep: true,
      handler () {
        if (!this.loading) {
          this.cambiado = true
          this.$emit('cambiado', this.cambiado)
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/promociones/PopUpPromocionTasaScoring.vue